module.exports = __webpack_public_path__ + "img/icon.e4fd3e04.png";